const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "99%",
  },

  tabs: {
    pt: 1,
    "& .MuiTabs-indicator": {
      display: "flex",
      justifyContent: "center",

      borderRadius: "5px 5px 0 0",
      p: 0.2,
    },
    "& button": {
      textTransform: "none",
    },

    borderBottom: 1,
    borderColor: "divider",

    width: "100%",
    "& .MuiTabs-flexContainer": {
      gap: 2.5,
    },
  },
  buttonRefresh: {
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    minWidth: "25px",
    padding: "10px",
    lineHeight: 1,
  },
  boxTab: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: "1rem",
  },
  boxLoading: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "500px",
  },
  containerBuscar: {
    display: "flex",

    width: "100%",
    maxWidth: 500,
  },
  textField: {
    width: "100%",
    maxWidth: 500,
    fontSize: "0.75rem", // diminui fonte geral

    "@media (max-width: 1349px)": {
      width: "100%",
    },
  },
});
export default styles;
